// TODO: refactor
export const getCPVParents = (codeToSearch, CPVs) => {
  let parents = []
  CPVs.forEach(CPVLvl1 => {
    if (CPVLvl1.id === codeToSearch) {
      parents = [{ ...CPVLvl1 }]
    } else {
      if (CPVLvl1.sublevel) {
        CPVLvl1.sublevel.forEach(CPVLvl2 => {
          if (CPVLvl2.id === codeToSearch) {
            parents = [{ ...CPVLvl1 }, { ...CPVLvl2 }]
          } else {
            if (CPVLvl2.sublevel) {
              CPVLvl2.sublevel.forEach(CPVLvl3 => {
                if (CPVLvl3.id === codeToSearch) {
                  parents = [{ ...CPVLvl1 }, { ...CPVLvl2 }, { ...CPVLvl3 }]
                }
              })
            }
          }
        })
      }
    }
  })
  return parents
}

const getCPVById = (id, CPVs) => {
  let CPV = []
  CPVs.forEach(CPVLvl1 => {
    if (CPVLvl1.id === id) {
      CPV = { ...CPVLvl1 }
    } else {
      if (CPVLvl1.sublevel) {
        CPVLvl1.sublevel.forEach(CPVLvl2 => {
          if (CPVLvl2.id === id) {
            CPV = { ...CPVLvl2 }
          } else {
            if (CPVLvl2.sublevel) {
              CPVLvl2.sublevel.forEach(CPVLvl3 => {
                if (CPVLvl3.id === id) {
                  CPV = { ...CPVLvl3 }
                }
              })
            }
          }
        })
      }
    }
  })
  return CPV
}

const getVendorTypesByIds = (ids, vendorTypes) =>
  vendorTypes.filter(vendorType => ids.includes(vendorType.id))

const getCountryById = (id, countries) =>
  countries.find(country => parseInt(country.id) === parseInt(id))

const getProvincesByIds = (ids, provinces) =>
  provinces.filter(province => ids.includes(province.id))

const getDocumentsByIds = (ids, documents) =>
  documents.filter(document => ids.includes(document.id))

export const getSearchesWithCPVInfo = (searches, CPVs) => {
  return searches.map(search => {
    const cpvInfo = search.cpv
      ? getCPVParents(search.cpv.id, CPVs).map(cpv => ({
          label: cpv.name,
        }))
      : null

    return { ...search, cpvInfo }
  })
}

export const formatSearchOptions = (options, searchName = null) => {
  const formattedOptions = []
  if (options) {
    for (var key in options) {
      formattedOptions.push({
        id: options[key].id,
        name: options[key].name,
        pathname: `/app/vendors/${options[key].id}`,
        back: {
          from: searchName ? 'savedSearch' : 'search',
          params: searchName ? { search: searchName } : {},
        },
      })
    }
  }
  return formattedOptions
}

export const getSearchFiltersByParams = (query, searchConfig) => {
  const searchFilters = {}

  const queryCPV = query.get('cpv')
  if (queryCPV) {
    const CPV = getCPVParents(queryCPV, searchConfig.CPVs)
    searchFilters.CPV = CPV
  }

  const queryVendorTypes = query.get('vendor_types[]')
  if (queryVendorTypes) {
    const ids = queryVendorTypes.split(',')
    searchFilters.vendor_types = getVendorTypesByIds(
      ids,
      searchConfig.vendorTypes,
    )
  }

  const queryCountry = query.get('country')
  if (queryCountry) {
    searchFilters.country = getCountryById(
      +queryCountry,
      searchConfig.countries,
    )
  }

  const queryProvinces = query.get('states[]')
  if (queryProvinces) {
    // const ids = queryDocuments.split(',').map(id => +id)
    const ids = queryProvinces.split(',')
    searchFilters.provinces = getProvincesByIds(ids, searchConfig.provinces)
  }

  const querySearchNetwork = query.get('search_network')
  if (querySearchNetwork) {
    searchFilters.search_network = querySearchNetwork
  }

  const queryDocuments = query.get('documents[]')
  if (queryDocuments) {
    // const ids = queryDocuments.split(',').map(id => +id)
    const ids = queryDocuments.split(',')
    searchFilters.documents = getDocumentsByIds(
      ids,
      searchConfig.documents.concat(searchConfig.requirements),
    )
  }

  const queryInvalidDocuments = query.get('invalid_documents')
  if (queryInvalidDocuments) {
    searchFilters.invalid_documents = queryInvalidDocuments
  }

  return searchFilters
}

export const getSearchBodyData = filters => {
  const data = {}

  if (filters.CPV && filters.CPV.length) {
    data.cpv = filters.CPV.slice(-1)[0].id
  }
  if (filters.vendor_types && filters.vendor_types.length) {
    data.vendor_types = filters.vendor_types.map(vendor_type => vendor_type.id)
  }
  if (filters.country) {
    data.country = filters.country.id
  }
  if (filters.provinces) {
    data.states = filters.provinces.map(province => province.id)
  }
  if (filters.search_network) {
    data.search_network = filters.search_network
  }
  if (filters.documents && filters.documents.length) {
    data.documents = filters.documents.map(document => document.id)
  }
  if (filters.invalid_documents) {
    data.invalid_documents = filters.invalid_documents
  }

  return data
}

export const getSearchURLParams = filters => {
  const params = []

  if (filters.CPV && filters.CPV.length) {
    params.push(
      `cpv=${
        filters.CPV[2]
          ? filters.CPV[2].id
          : filters.CPV[1]
          ? filters.CPV[1].id
          : filters.CPV[0].id
      }`,
    )
  }
  if (filters.vendor_types && filters.vendor_types.length) {
    params.push(
      `vendor_types[]=${filters.vendor_types
        .map(vendor_type => vendor_type.id)
        .join(',')}`,
    )
  }
  if (filters.country) {
    params.push(`country=${filters.country.id}`)
  }
  if (filters.provinces && filters.provinces.length) {
    params.push(
      `states[]=${filters.provinces.map(province => province.id).join(',')}`,
    )
  }
  if (filters.search_network && filters.search_network > 0) {
    params.push(`search_network=${filters.search_network}`)
  }
  if (filters.documents && filters.documents.length) {
    params.push(
      `documents[]=${filters.documents.map(document => document.id).join(',')}`,
    )
  }
  if (filters.invalid_documents && filters.invalid_documents !== 0) {
    params.push(`invalid_documents=${filters.invalid_documents}`)
  }

  return params.join('&')
}

export const getExistingSearchFilters = (filters, searchConfig) => {
  const searchFilters = {}

  if (filters.cpv) {
    searchFilters.CPV = getCPVParents(filters.cpv.id, searchConfig.CPVs)
  }

  if (filters.vendor_types) {
    searchFilters.vendor_types = getVendorTypesByIds(
      filters.vendor_types,
      searchConfig.vendorTypes,
    )
  }

  if (filters.country) {
    searchFilters.country = getCountryById(
      filters.country,
      searchConfig.countries,
    )
  }

  if (filters.states) {
    // const ids = filters.documents.map(id => +id)
    searchFilters.provinces = getProvincesByIds(
      filters.states,
      searchConfig.provinces,
    )
  }

  if (filters.search_network) {
    searchFilters.search_network = filters.search_network
  }

  if (filters.documents && filters.documents.length) {
    // const ids = filters.documents.map(id => +id)
    searchFilters.documents = getDocumentsByIds(
      filters.documents,
      searchConfig.documents.concat(searchConfig.requirements),
    )
  }

  if (filters.invalid_documents) {
    searchFilters.invalid_documents = filters.invalid_documents
  }

  return searchFilters
}

export const makeDataToExport = (vendors, config, t) => {
  const vendorsToExport = vendors.map(vendor => {
    const vendorToExport = {}

    vendorToExport[`${t('csv:code')}`] = vendor.identification_code || ''
    vendorToExport[`${t('csv:name')}`] = vendor.name || ''
    vendorToExport[`${t('csv:homologated')}`] = vendor.homologated
      ? t('csv:yes')
      : t('csv:no')
    vendorToExport[`${t('csv:first-homologation-date')}`] =
      vendor.first_homologation_date || ''
    vendorToExport[`${t('csv:is-in-my-network')}`] = vendor.is_in_my_network
      ? t('csv:yes')
      : t('csv:no')
    vendorToExport[`${t('csv:capital-stock')}`] = vendor.capital_stock || ''

    if (vendor.business_contact) {
      vendorToExport[`${t('csv:business-contact')} - ${t('csv:name')}`] =
        vendor.business_contact.name || ''
      vendorToExport[`${t('csv:business-contact')} - ${t('csv:email')}`] =
        vendor.business_contact.email || ''
      vendorToExport[`${t('csv:business-contact')} - ${t('csv:phone')}`] =
        vendor.business_contact.phone || ''
      vendorToExport[`${t('csv:business-contact')} - ${t('csv:web')}`] =
        vendor.business_contact.web || ''
      vendorToExport[`${t('csv:business-contact')} - ${t('csv:address')}`] =
        vendor.business_contact.address || ''
    }

    if (vendor.business_group) {
      vendorToExport[`${t('csv:business-group')} - ${t('csv:code')}`] =
        vendor.business_group.identification_code || ''
      vendorToExport[`${t('csv:business-group')} - ${t('csv:name')}`] =
        vendor.business_group.name || ''
      if (vendor.business_group.country_code) {
        const businessGroupCountry = config.countries.filter(function (
          country,
        ) {
          return (
            vendor.business_group.country_code &&
            country.id.toString() ===
              vendor.business_group.country_code.toString()
          )
        })
        if (businessGroupCountry && businessGroupCountry.length) {
          vendorToExport[`${t('csv:business-group')} - ${t('csv:country')}`] =
            businessGroupCountry[0].name
        }
      }
    }

    vendorToExport[`${t('csv:date-of-incorporation')}`] =
      vendor.date_of_incorporation || ''

    if (!vendor.documents) {
      vendor.documents = []
    }

    const documents = config.documents.concat(
      config.requirements.map(requirement => ({
        ...requirement,
        required: true,
      })),
    )
    const documentsData = getDocumentsByIds(vendor.documents, documents)

    vendorToExport[
      `${t('csv:documents')} - ${t('csv:required')}`
    ] = documentsData
      .filter(function (document) {
        return document.required
      })
      .map(document => document.name)
      .join(', ')

    vendorToExport[
      `${t('csv:documents')} - ${t('csv:missing-required')}`
    ] = documents
      .filter(function (document) {
        return (
          document.required &&
          !vendor.documents.includes(document.id) &&
          vendor.requested_documents &&
          vendor.requested_documents.includes(document.id)
        )
      })
      .map(document => document.name)
      .join(', ')

    vendorToExport[
      `${t('csv:documents')} - ${t('csv:certificates')}`
    ] = documentsData
      .filter(function (document) {
        return !document.required
      })
      .map(document => document.name)
      .join(', ')

    vendorToExport[`${t('csv:overall-number-of-staff')}`] =
      vendor.overall_number_of_staff || ''

    if (vendor.cpv) {
      vendorToExport[`${t('csv:cpv')}`] = vendor.cpv
        .map(cpv => getCPVById(cpv.id, config.CPVs).name)
        .join(', ')
    }

    if (vendor.vendor_types) {
      vendorToExport[`${t('csv:vendor-types')}`] = getVendorTypesByIds(
        vendor.vendor_types,
        config.vendorTypes,
      )
        .map(type => type.name)
        .join(', ')
    }

    if (vendor.scopes_of_action) {
      vendorToExport[
        `${t('csv:scopes-of-action')}`
      ] = vendor.scopes_of_action
        .map(
          province => getProvincesByIds(province.state, config.provinces).name,
        )
        .join(', ')
    }

    if (vendor.turnover) {
      vendorToExport[`${t('csv:turnover')} - ${t('csv:amount')}`] =
        vendor.turnover.amount || ''
      vendorToExport[`${t('csv:turnover')} - ${t('csv:year')}`] =
        vendor.turnover.year || ''
    }

    return vendorToExport
  })

  return vendorsToExport
}

export const processServerError = (status, errors) => {
  if (status === 401) return false

  const statusString = status.toString()
  if (
    (statusString.startsWith(4) || statusString.startsWith(5)) &&
    errors.detail
  ) {
    return { generic: errors.detail }
  }

  return false
}
